angular.module('gym.calendar').directive('eventAttendees', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/calendar/events/edit_event_schedule/general/event_attendees.html.slim'),
    scope: {
      event: '=',
      bookings: '=',
      getBookings: '&',
      reloadEvent: '&',
      recurringBookings: '=',
      showAllBookingsAvailable: '&',
      showAllBookings: '&'
    },
    controller: ["$scope", "$rootScope", "$stateParams", "$modal", "$state", "$window", "$interval", "$q", "$http", "flash", "LateCancellationService", "FeatureAvailabilityService", "ContactBadgeService", "EventService", "EventMessageService", "MessageService", "EmploymentService", "MemberForms", "GTMService", "KioskService", "ReactModal", function($scope, $rootScope, $stateParams, $modal, $state, $window, $interval, $q, $http, flash, LateCancellationService, FeatureAvailabilityService, ContactBadgeService, EventService, EventMessageService, MessageService, EmploymentService, MemberForms, GTMService, KioskService, ReactModal) {
      var eventId, gym, gymId, intervalId, reloadAttendance;
      $scope.gym = gym = $rootScope.gym;
      $scope.currency = gym.currency_symbol;
      gymId = $stateParams.gymId;
      eventId = $stateParams.eventId;
      $scope.permissions = EmploymentService.get().permissions;
      $scope.attendanceFeatureAvailable = FeatureAvailabilityService.isAvailable('attendance');
      $scope.orderContactsBy = 'last_name';
      $scope.$watch('event', function(newVal) {
        var ref;
        if (newVal == null) {
          return;
        }
        return $scope.isZeroBookingEvent = (ref = newVal.participant_limit) === 0 || ref === (void 0) || ref === null;
      });
      MemberForms.getList().then(function(forms) {
        return $scope.attendanceField = _.find(_.find(forms, {
          name: 'bookings'
        }).fields, {
          name: 'attendance'
        });
      });
      $scope.getSortedValue = function(booking) {
        return booking.student[$scope.orderContactsBy];
      };
      $scope.setOrderBy = function(orderBy) {
        return $scope.orderContactsBy = orderBy;
      };
      $scope.getCancelledBookingsCount = function() {
        if (!$scope.bookings) {
          return 0;
        }
        return $scope.bookings.filter(function(b) {
          return !b.move_details || !b.move_details.moved_to_event_id;
        }).length;
      };
      $scope.getMovedBookingsCount = function() {
        if (!$scope.bookings) {
          return 0;
        }
        return $scope.bookings.filter(function(b) {
          return b.move_details && b.move_details.moved_to_event_id;
        }).length;
      };
      $scope.getMovedEventTooltip = function(booking) {
        if (!booking.move_details) {
          return '';
        }
        return `<div>
  ${booking.move_details.moved_to_event_name}
  <br/>
  ${$scope.getMovedEventTime(booking.move_details)}
</div>`;
      };
      intervalId = null;
      if (!$scope.event.cancelled) {
        intervalId = $interval(function() {
          return $scope.reloadEvent({
            autoUpdate: true
          }, true);
        }, 20000);
      }
      $scope.$on('$destroy', function() {
        if (intervalId) {
          return $interval.cancel(intervalId);
        }
      });
      $scope.addBooking = function(contact) {
        EventService.addBooking(contact, $scope.event, $scope.bookings).then(function() {
          $scope.getBookings();
          return $scope.reloadEvent();
        });
        return $scope.search = '';
      };
      $scope.usesTypeLimits = $scope.gym.gym_config.uses_event_type_attendee_limits;
      reloadAttendance = function() {
        $scope.getBookings();
        return $scope.reloadEvent();
      };
      $scope.resetAttendance = function(booking) {
        if (window.confirm("This will reset the attendance status for this booking. Are you sure?")) {
          booking.attendance = null;
          return EventService.resetAttendance(booking, reloadAttendance);
        }
      };
      $scope.updateAttendance = function(booking, value) {
        var previousValue;
        previousValue = booking.attendance;
        booking.attendance = value;
        return EventService.confirmUpdateAttendance({
          event: $scope.event,
          booking: booking,
          studentName: booking.student.name,
          previousValue: previousValue,
          reloadAttendance: reloadAttendance
        });
      };
      $scope.messageAttendees = function() {
        GTMService.trackPage('Event details', 'Message attendees');
        EventMessageService.messageAttendees($scope.bookings);
        return $state.go('gym.bulkMessages.new', {
          eventId: eventId
        });
      };
      $scope.sendMessage = function(attendee) {
        EventMessageService.messageAttendees([attendee]);
        return $state.go('gym.bulkMessages.new', {
          eventId: eventId
        });
      };
      $scope.goToRollCall = function() {
        var url;
        GTMService.trackPage('Event details', 'Enter roll call');
        if ($scope.attendanceFeatureAvailable) {
          url = `/gyms/${$stateParams.gymId}/roll_call/${$stateParams.eventId}`;
          $window.open(url, '_self');
          return true;
        } else {
          return FeatureAvailabilityService.showNotAvailableMessage('General Kiosk');
        }
      };
      $scope.getContactBadge = function(type, status) {
        return ContactBadgeService.get(type, status);
      };
      $scope.isOverbooked = function() {
        return $scope.event.non_absent_bookings_count > $scope.event.participant_limit;
      };
      $scope.noPlacesAvailable = function() {
        return $scope.event.non_absent_bookings_count >= $scope.event.participant_limit;
      };
      $scope.addMakeUpClassAvailable = function(booking) {
        return $scope.permissions.manage_makeup_classes && booking.attendance === 'Absent' && booking.membership_id && !booking.membership_archived;
      };
      $scope.addMakeUpClass = function(booking) {
        return $modal.open({
          template: require('templates/components/membership/membership_make_up_modal.html.slim'),
          resolve: {
            membership: function() {
              return {
                id: booking.membership_id,
                label: booking.membership_name,
                expiration_date: booking.membership_expiration_date
              };
            },
            makeUpClass: function() {
              return {};
            },
            contact: function() {
              return booking.student;
            }
          },
          controller: 'MembershipMakeUpClassModalCtrl'
        });
      };
      $scope.showInfo = function(booking) {
        var modalInstance;
        return modalInstance = $modal.open({
          template: require('templates/gyms/calendar/events/booking_info_modal.html.slim'),
          resolve: {
            booking: function() {
              return booking;
            }
          },
          controller: 'BookingInfoCtrl'
        });
      };
      $scope.deleteBooking = function(booking) {
        return EventService.removeBooking(booking, $scope.event).then(function() {
          $scope.getBookings();
          return $scope.reloadEvent();
        });
      };
      $scope.getMovedEventTime = function(moveDetails) {
        var date, endTime, startTime;
        if (!moveDetails) {
          return '';
        }
        startTime = moment(moveDetails.moved_to_event_start_at).format('h:mm A');
        endTime = moment(moveDetails.moved_to_event_end_at).format('h:mm A');
        date = moment(moveDetails.moved_to_event_start_at).format('dddd D MMMM YYYY');
        return `${startTime} - ${endTime} on ${date}`;
      };
      $scope.goToMovedEvent = function(eventId) {
        var url;
        url = $state.href('gym.editEvent', {
          eventId: eventId
        });
        return $window.open(url, '_blank');
      };
      $scope.openBulkAddAttendees = function(event) {
        return ReactModal.open({
          component: 'BulkAddAttendeesModal',
          size: 'lg',
          props: {
            event: event,
            from: 'show_event'
          }
        });
      };
      $scope.getRecurringBooking = function(contactId) {
        var ref;
        return (ref = $scope.recurringBookings) != null ? ref.find(function(item) {
          return item.contact_id === contactId;
        }) : void 0;
      };
      $scope.enableRecurringBookingsVisible = function(booking) {
        return gym.gym_config.recurring_bookings_feature_enabled && $scope.event.all_events_count > 1 && !$scope.getRecurringBooking(booking.student.id);
      };
      $scope.enableRecurringBookings = function(booking) {
        var modalInstance;
        modalInstance = ReactModal.open({
          component: 'EnableRecurringBookingsModal',
          props: {
            booking: booking,
            event: $scope.event.plain()
          }
        });
        return modalInstance.then(function() {
          return $scope.reloadEvent();
        });
      };
      $scope.disableRecurringBookings = function(booking) {
        var modalInstance;
        modalInstance = ReactModal.open({
          component: 'DisableRecurringBookingsModal',
          props: {
            booking: booking,
            event: $scope.event.plain(),
            recurringBooking: $scope.getRecurringBooking(booking.student.id)
          }
        });
        return modalInstance.then(function() {
          return $scope.reloadEvent();
        });
      };
      $scope.goToEventKiosk = function() {
        var params;
        GTMService.trackPage('Event details', 'Enter kiosk mode');
        if ($scope.attendanceFeatureAvailable) {
          params = {
            event_id: $stateParams.eventId,
            location_id: $stateParams.location_id
          };
          return KioskService.enterClassKioskMode(params);
        } else {
          return FeatureAvailabilityService.showNotAvailableMessage('General Kiosk');
        }
      };
      return $scope.getBookings();
    }]
  };
});
